import { call, put, takeLatest } from "redux-saga/effects";
import {
  SUBMIT_DELIVERY_EXCELLENCE_REQUEST,
  submitDeliveryExcellenceSuccess,
  submitDeliveryExcellenceFailure,
} from "../actions/deliveryExcellenceActions";
import { fetchDeliveryExcellenceAgent } from "../../../services/accIqService";

function* handleSubmitDeliveryExcellence(action) {
  try {
    const result = yield call(
        fetchDeliveryExcellenceAgent, 
        action.payload.formData.clientName,
        action.payload.formData.accountName,
        action.payload.formData.context,
        action.payload.formData.contextFile,
        action.payload.formData.outputFile,
        action.payload.formData.contact,
        action.payload.formData.response_type

    );
    yield put(submitDeliveryExcellenceSuccess(result?.html || "Delivery Excellence note not generated"));
  } catch (error) {
    yield put(submitDeliveryExcellenceFailure(error.message));
  }
}

export default function* watchDeliveryExcellence() {
  yield takeLatest(
    SUBMIT_DELIVERY_EXCELLENCE_REQUEST,
    handleSubmitDeliveryExcellence
  );
}
